import { initDatadog } from '@cartwhl/tracking/datadog';
import { StrictMode } from 'react';
import { hydrateRoot } from 'react-dom/client';
import { HydratedRouter } from 'react-router/dom';

import * as userStore from '@cartwhl/common/stores/userStore';

import { authStore } from 'stores/global';

// Homepage visits start in light mode without changing the preference used by other apps.
userStore.setTheme('light', { persist: false });
authStore.init();

const disambiguator = import.meta.env.VITE_API_DISAMBIGUATOR ?? 'unknown';
const env = disambiguator === '' ? 'prod' : disambiguator;

initDatadog({
  service: 'homepage',
  env,
  isDevelopment: process.env.NODE_ENV === 'development',
});

hydrateRoot(
  document,
  <StrictMode>
    <HydratedRouter />
  </StrictMode>,
);
